import { ReactNode } from "react";
import { IconHelp } from "./Icons";
import { EbTooltip } from "./EbTooltip";

interface Props {
  helpText: string;
  labelText: string;
  children?: ReactNode;
}

export const LabelWithTooltipHelp = (props: Props) => {
  const preventLabelCapture = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const helpIcon = (
    <EbTooltip label={props.helpText}>
      <span
        aria-label="Help"
        style={{
          display: "inline-flex",
          cursor: "help",
          pointerEvents: "auto",
        }}
        onMouseDown={preventLabelCapture}
        onClick={preventLabelCapture}
      >
        <IconHelp />
      </span>
    </EbTooltip>
  );

  if (props.children) {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          pointerEvents: "auto",
        }}
      >
        {props.children}
        {helpIcon}
      </span>
    );
  }

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        pointerEvents: "auto",
      }}
    >
      <span>{props.labelText}</span>
      {helpIcon}
    </span>
  );
};
